module.exports = __webpack_public_path__ + "static/media/Hero_Bg.d64c8594.png";